import { render, staticRenderFns } from "./ReorderData.vue?vue&type=template&id=069fcd6c&scoped=true&"
import script from "./ReorderData.vue?vue&type=script&lang=js&"
export * from "./ReorderData.vue?vue&type=script&lang=js&"
import style0 from "./ReorderData.vue?vue&type=style&index=0&id=069fcd6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fcd6c",
  null
  
)

export default component.exports